/**
 * Detect if running inside a Discord Activity iframe.
 * Activities are served from *.discordsays.com
 */
export function isDiscordActivity(): boolean {
  if (typeof window === 'undefined') return false;
  if (import.meta.env.DEV && import.meta.env.VITE_FORCE_DISCORD_ACTIVITY === '1') return true;
  return window.location.host.endsWith('.discordsays.com');
}
